import React from 'react';

export function DebugIcon() {
  return (
    <svg fill='none' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'>
      <path
        clipRule='evenodd'
        d='M20 8H17.1899C16.74 7.22 16.12 6.55 15.37 6.04L17 4.41L15.59 3L13.42 5.17C12.96 5.06 12.49 5 12 5C11.51 5 11.04 5.06 10.59 5.17L8.41003 3L7 4.41L8.62 6.04C7.88 6.55 7.26001 7.22 6.81006 8H4V10H6.08997C6.04004 10.33 6 10.66 6 11V12H4V14H6V15C6 15.34 6.04004 15.67 6.08997 16H4V18H6.81006C7.84998 19.79 9.78003 21 12 21C14.22 21 16.15 19.79 17.1899 18H20V16H17.91C17.96 15.67 18 15.34 18 15V14H20V12H18V11C18 10.66 17.96 10.33 17.91 10H20V8ZM14 16H10V14H14V16ZM10 12H14V10H10V12Z'
        fill='black'
        fillOpacity='0.54'
        fillRule='evenodd'
      />
    </svg>
  );
}
